import React from "react";
import { Container ,Toast } from "react-bootstrap";
import PropTypes from 'prop-types'

import './ToastMessage.scss';

function ToastMessage(props) {
	const delay = props.delay ? props.delay : 5000;
	const toastClass = props.toastClass ? props.toastClass : 'toast-error';
	const zIndex = props.show ? {zIndex: 1200} : {zIndex: -1};

	return (
		<Container className="d-flex justify-content-center align-items-center overlay" style={zIndex}>
			<Toast onClose={() => props.setShow && props.setShow(false)} show={props.show} delay={delay} autohide animation bsPrefix="toast-message">
				<Toast.Header bsPrefix={toastClass}>
					<strong>{props.message}</strong>
				</Toast.Header>
				{
					//<Toast.Body></Toast.Body>
				}
			</Toast>
		</Container>
	);
}

ToastMessage.propTypes = {
	setShow: PropTypes.func,
	show: PropTypes.bool.isRequired,
	delay: PropTypes.number,
	message: PropTypes.string.isRequired,
	toastClass: PropTypes.oneOf(['', 'toast-error', 'toast-success']),
}

export default ToastMessage;